import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20modern%20digital%20art%20background%20with%20warm%20orange%20and%20amber%20gradient%20tones%2C%20soft%20geometric%20shapes%2C%20subtle%20comic%20panel%20style%20texture%2C%20minimalist%20design%2C%20clean%20composition%2C%20no%20text%2C%20atmospheric%20lighting%2C%20professional%20digital%20illustration%20suitable%20for%20website%20hero%20background&width=1920&height=700&seq=hero-comic-bg-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-6 leading-tight">
            下拉式完整版
            <span className="block text-accent-400">免费阅读</span>
          </h1>
          <p className="text-sm md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            无删减韩国漫画资源充足，下拉观看流畅不卡顿，
            免费为您呈现各类精彩韩国漫画的完整版剧情与画面
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/hot"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-fire-line"></i>
              </div>
              热门推荐
            </Link>
            <Link
              to="/category/hot"
              className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm hover:bg-background-50/25 transition-colors border border-background-50/20 whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-compass-3-line"></i>
              </div>
              开始探索
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-background-50">500+</p>
              <p className="text-xs text-background-50/60 mt-1">漫画资源</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-background-50">8大</p>
              <p className="text-xs text-background-50/60 mt-1">分类频道</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-background-50">100%</p>
              <p className="text-xs text-background-50/60 mt-1">免费无删减</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}